import { MutationTree } from 'vuex';
import { AkimatsState, AkimatTree } from '@/store/akimats/types';

export const mutations: MutationTree<AkimatsState> = {
  setTree(state, payload: AkimatTree) {
    state.tree = payload;
  },
};
